export default __webpack_public_path__ + "static/media/editblack.9bbb9d87.svg";